import { EngineCameraStateModel } from './engine.camera.state.model';
import { SetCameraFlyTo } from './engine.camera.actions';

declare const immer;

export function calcCameraFlyToState(
  state: EngineCameraStateModel,
  action: SetCameraFlyTo
) {
  const [nextState, patches, inversePatches] = immer.produceWithPatches(
    state,
    (draft: EngineCameraStateModel) => {
      draft.cameraFlyTo = action.camera;
    }
  );

  return {
    nextState,
    patches,
    inversePatches,
  };
}
